import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import LayoutInner from '../../../../layouts/main/components/layout-inner/layout-inner';
import CustomButton from '../../../../shared/components/buttons/custom-button/custom-button';
import { PlusIcon } from '../../../../shared/icons/plus-icon';
import { useAppDispatch } from '../../../../store/hooks';
import AuthGuard from '../../../auth/components/auth-guard/auth-guard';
import { openModal } from '../../../ui/store/ui-slice';
import { UserPermissionType } from '../../../user/models/user-permission-type';
import CustomersContent from '../../components/customers-content/customers-content';
import { customersAlertId, customersFormModalId } from '../../constants/constants';

const Customers = (): JSX.Element => {
  const { t } = useTranslation(['customers', 'common']);
  const dispatch = useAppDispatch();

  return (
    <AuthGuard permission={UserPermissionType.ViewCustomers}>
      <Helmet>
        <title>{t('menu.customers', { ns: 'common' })}</title>
      </Helmet>
      <LayoutInner
        alertId={customersAlertId}
        headerActionButton={
          <CustomButton
            type="primaryLight"
            onClick={() => {
              dispatch(openModal(customersFormModalId));
            }}
            icon={<PlusIcon />}
          >
            {t('newCustomer')}
          </CustomButton>
        }
      >
        <CustomersContent />
      </LayoutInner>
    </AuthGuard>
  );
};

export default Customers;
